import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, X } from 'lucide-react';

const COMMENTARY_BY_SCOPE = {
  overview:        'Revenue is +8.4% YoY but margin is 2.8 pts below plan — driven by a 27% over-spend in marketing and lower realisation on the enterprise segment.',
  finance:         'Gross margin contracted 1.9 pts QoQ. Cost of Sales over-run is concentrated in raw materials (+12%) — procurement should review Q3 contracts.',
  sales:           'Pipeline coverage is healthy at 3.2× quota, but win-rate on deals over $100K dropped to 22% (vs 31% last quarter) — concentrated in the EMEA region.',
  operations:      'Service SLA is up 0.7pp to 98.6%, however unplanned downtime in Plant-2 cost 14 hours this month — root cause looks like a single line changeover.',
  'human capital': 'Headcount is -1.2% but voluntary attrition in Engineering jumped to 9% — concentrated in the 2–4 year tenure band.',
  hr:              'Headcount is -1.2% but voluntary attrition in Engineering jumped to 9% — concentrated in the 2–4 year tenure band.',
  'supply chain':  "Lead time improved to 3.4 days (-0.6d), but you're carrying 18% more safety stock on Category-A SKUs than the plan assumed.",
  supply:          "Lead time improved to 3.4 days (-0.6d), but you're carrying 18% more safety stock on Category-A SKUs than the plan assumed.",
  customer:        'NPS is +4 pts to 72, driven by onboarding and support — but detractor count rose 11% in the SMB segment, mostly billing-related.',
};

function getCommentary(scope) {
  const key = String(scope || '').toLowerCase().replace(/\s+dashboard$/, '').trim();
  return COMMENTARY_BY_SCOPE[key] || COMMENTARY_BY_SCOPE.overview;
}

export function AICommentaryPanel({ scope = 'Overview' }) {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  return (
    <div className="px-6 lg:px-10 mt-3 mb-1">
      <div style={{
        display: 'flex', alignItems: 'flex-start', gap: 10,
        padding: '11px 14px', borderRadius: 10,
        background: 'rgba(42,125,95,0.06)',
        border: '1px solid rgba(42,125,95,0.15)',
      }}>
        {/* Icon */}
        <div style={{
          width: 24, height: 24, borderRadius: 6, flexShrink: 0,
          background: 'var(--gradient-primary, linear-gradient(135deg,#2a7d5f,#1e6e52))',
          display: 'grid', placeItems: 'center',
        }}>
          <Sparkles style={{ width: 11, height: 11, color: '#fff' }} />
        </div>

        {/* Label */}
        <span style={{
          fontSize: 10, fontWeight: 600, letterSpacing: '0.16em',
          textTransform: 'uppercase', color: 'var(--primary)', flexShrink: 0,
        }}>
          AI Commentary
        </span>

        <span style={{ color: 'var(--muted-foreground)', flexShrink: 0, fontSize: 12 }}>·</span>

        {/* Commentary — wraps so the full insight remains visible */}
        <p style={{
          fontSize: 13, lineHeight: 1.4, color: 'var(--foreground)',
          margin: 0, flex: 1, minWidth: 0,
          whiteSpace: 'normal', overflowWrap: 'anywhere',
        }}>
          {getCommentary(scope)}
        </p>

        <Link to="/imagei/agents" style={{
          fontSize: 12, fontWeight: 500, color: 'var(--primary)',
          textDecoration: 'none', whiteSpace: 'nowrap', flexShrink: 0,
        }}>
          Ask follow-up ↗
        </Link>

        <button onClick={() => setVisible(false)} aria-label="Dismiss" style={{
          background: 'none', border: 'none', cursor: 'pointer', padding: 2,
          color: 'var(--muted-foreground)', display: 'flex', alignItems: 'center', flexShrink: 0,
        }}>
          <X style={{ width: 13, height: 13 }} />
        </button>
      </div>
    </div>
  );
}
